export class SDTKAddress {
  line1 = '';
  line2 = '';
  line3 = '';
  county = '';
  postcode = '';
}
